import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { FileText, Download, Pencil, Trash2, Eye } from "lucide-react";

const STATUS_META = {
  draft: { label: "Borrador", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  pending_review: { label: "Pendiente de revisión", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  approved: { label: "Aprobada", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rechazada", cls: "bg-red-100 text-red-700 border-red-200" },
};

const TYPE_LABELS = { initiative: "Iniciativa", pilot: "Piloto", grant: "Ayuda" };

export function ProposalCard({ proposal: p, canEdit, onView, onEdit, onDelete, onDownload }) {
  const meta = STATUS_META[p.status] || STATUS_META.draft;
  return (
    <Card data-testid={`proposal-card-${p.id}`}>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-start gap-2 min-w-0">
            <FileText className="w-5 h-5 text-emerald-700 mt-0.5 shrink-0" />
            <div className="min-w-0">
              <div className="font-semibold truncate" data-testid={`proposal-title-${p.id}`}>{p.title}</div>
              <div className="text-xs text-muted-foreground truncate">{p.linea_estrategica || "Sin línea estratégica"}</div>
            </div>
          </div>
          <Badge variant="outline" className={`shrink-0 ${meta.cls}`} data-testid={`proposal-status-${p.id}`}>{meta.label}</Badge>
        </div>

        {p.linked_entities?.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {p.linked_entities.slice(0, 3).map((e, i) => (
              <Badge key={i} variant="secondary" className="text-[10px]">{TYPE_LABELS[e.entity_type]}: {e.entity_name}</Badge>
            ))}
            {p.linked_entities.length > 3 && <Badge variant="secondary" className="text-[10px]">+{p.linked_entities.length - 3}</Badge>}
          </div>
        )}

        <div className="text-xs text-muted-foreground">Por {p.created_by_name || p.created_by} · v{p.version}</div>

        <div className="flex items-center gap-1.5 pt-1">
          <Button size="sm" variant="outline" onClick={() => onView(p)} data-testid={`proposal-view-btn-${p.id}`}><Eye className="w-3.5 h-3.5 mr-1.5" />Ver</Button>
          <Button size="sm" variant="outline" onClick={() => onDownload(p)} data-testid={`proposal-download-btn-${p.id}`}><Download className="w-3.5 h-3.5" /></Button>
          {canEdit && ["draft", "rejected"].includes(p.status) && (
            <Button size="sm" variant="outline" onClick={() => onEdit(p)} data-testid={`proposal-edit-btn-${p.id}`}><Pencil className="w-3.5 h-3.5" /></Button>
          )}
          {canEdit && (
            <Button size="sm" variant="outline" className="text-red-600 hover:text-red-700" onClick={() => onDelete(p)} data-testid={`proposal-delete-btn-${p.id}`}><Trash2 className="w-3.5 h-3.5" /></Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
